export default "__VITE_ASSET__phZEjbTZ__"